var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3H15C17.2091 3 19 4.79086 19 7V17C19 19.2091 17.2091 21 15 21H5C2.79086 21 1 19.2091 1 17V7C1 4.79086 2.79086 3 5 3H6M14 3C14 4.10457 13.1046 5 12 5H8C6.89543 5 6 4.10457 6 3M14 3C14 1.89543 13.1046 1 12 1H8C6.89543 1 6 1.89543 6 3M10 9H14M10 13H14M10 17H14",
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9C7.5 9.55228 7.05228 10 6.5 10C5.94772 10 5.5 9.55228 5.5 9C5.5 8.44772 5.94772 8 6.5 8C7.05228 8 7.5 8.44772 7.5 9Z",
    fill: "#3C7795"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13C7.5 13.5523 7.05228 14 6.5 14C5.94772 14 5.5 13.5523 5.5 13C5.5 12.4477 5.94772 12 6.5 12C7.05228 12 7.5 12.4477 7.5 13Z",
    fill: "#3C7795"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17C7.5 17.5523 7.05228 18 6.5 18C5.94772 18 5.5 17.5523 5.5 17C5.5 16.4477 5.94772 16 6.5 16C7.05228 16 7.5 16.4477 7.5 17Z",
    fill: "#3C7795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.e77b614ab489e9d8b051f699388c6cf8.svg";
export { ForwardRef as ReactComponent };